import React from "react";
import {AutomatedCampaignType, CampaignBigType} from "./dataForActiveCampaign";

export enum CampaignProgress {
    group= "Groups",
    campaignBigType= "Campaign Type",
    designCampaign = "Design Campaign",
    summary= "Summary",
    patientPreview = "Patient Preview"
}

interface IProps {
    campaignBigType: CampaignBigType,
    automatedCampaignType: AutomatedCampaignType,
    progress: CampaignProgress,
    disablePastProgress?: boolean
}

function CampaignProgressBar(props: IProps) {
    const {progress, campaignBigType, automatedCampaignType, disablePastProgress = false} = props

    const data: Array<CampaignProgress | string> = (automatedCampaignType === AutomatedCampaignType.appointment || automatedCampaignType === AutomatedCampaignType.postAppointment)
        ? [CampaignProgress.campaignBigType, "", CampaignProgress.designCampaign, "", CampaignProgress.summary]
        : [CampaignProgress.campaignBigType, "", CampaignProgress.group, "", CampaignProgress.designCampaign, "", CampaignProgress.summary]
    const targetIndex = data.findIndex((_item) => {
        return _item === progress
    })

    const $checkedIcon = (disabled: boolean) => {
        let circle = disabled ? <circle cx="12.5" cy="12" r="9.5" fill="#BDBDBD" stroke="#BDBDBD"/> : <circle cx="12.5" cy="12" r="9.5" fill="#219653" stroke="#219653"/>
        return (
            <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_f_295_630)">
                    {circle}
                    <path d="M11.7257 15.4509C11.5205 15.4509 11.3153 15.373 11.1586 15.2164L8.98496 13.0427C8.67168 12.7294 8.67168 12.2219 8.98496 11.9096C9.29823 11.5963 9.80478 11.5954 10.1181 11.9086L11.7257 13.5162L15.5069 9.73496C15.8202 9.42168 16.3268 9.42168 16.64 9.73496C16.9533 10.0482 16.9533 10.5557 16.64 10.869L12.2927 15.2164C12.136 15.373 11.9308 15.4509 11.7257 15.4509Z" fill="white"/>
                </g>
                {circle}
                <path d="M11.7257 15.4509C11.5205 15.4509 11.3153 15.373 11.1586 15.2164L8.98496 13.0427C8.67168 12.7294 8.67168 12.2219 8.98496 11.9096C9.29823 11.5963 9.80478 11.5954 10.1181 11.9086L11.7257 13.5162L15.5069 9.73496C15.8202 9.42168 16.3268 9.42168 16.64 9.73496C16.9533 10.0482 16.9533 10.5557 16.64 10.869L12.2927 15.2164C12.136 15.373 11.9308 15.4509 11.7257 15.4509Z" fill="white"/>
                <defs>
                    <filter id="filter0_f_295_630" x="0.5" y="0" width="24" height="24" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                        <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                        <feGaussianBlur stdDeviation="1" result="effect1_foregroundBlur_295_630"/>
                    </filter>
                </defs>
            </svg>
        )
    }

    const $progressIcon = (
        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_f_295_648)">
                <circle cx="12.5" cy="12" r="10" fill="#219653" fillOpacity="0.1"/>
                <circle cx="12.5" cy="12" r="9.75" stroke="#219653" strokeWidth="0.5"/>
            </g>
            <circle cx="12.5" cy="12" r="9.5" fill="#219653" fillOpacity="0.1" stroke="#219653"/>
            <defs>
                <filter id="filter0_f_295_648" x="0.5" y="0" width="24" height="24" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                    <feGaussianBlur stdDeviation="1" result="effect1_foregroundBlur_295_648"/>
                </filter>
            </defs>
        </svg>
    )

    const $uncheckedIcon = (
        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_f_295_654)">
                <circle cx="12.5" cy="12" r="10" fill="#E0E0E0" fillOpacity="0.3"/>
                <circle cx="12.5" cy="12" r="9.75" stroke="#828282" strokeWidth="0.5"/>
            </g>
            <circle cx="12.5" cy="12" r="9.5" fill="#E0E0E0" fillOpacity="0.3" stroke="#828282"/>
            <defs>
                <filter id="filter0_f_295_654" x="0.5" y="0" width="24" height="24" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                    <feGaussianBlur stdDeviation="1" result="effect1_foregroundBlur_295_654"/>
                </filter>
            </defs>
        </svg>
    )

    const $progressItem = (title: string, idx:number) => {
        const selectedIndex = data.findIndex((item) => item === progress)
        if (!title.length) {
            return <div key={idx} className={`w-3 lg:w-16 h-4 lg:h-px border-r-2 lg:border-b-2 border-dashed ${idx < targetIndex ? "border-progress-green" : "border-base-border"}`}/>
        }
        if (campaignBigType !== CampaignBigType.regularCampaign && title === CampaignProgress.group) {
            title = "Filters"
        }
        return (
            <div key={idx} className={"flex flex-none flex-row items-center justify-center "}>
                {idx < targetIndex ? $checkedIcon(disablePastProgress && idx < selectedIndex) : (idx === targetIndex ? $progressIcon : $uncheckedIcon)}
                <p className={"text-gray-1 text-sm font-semibold ml-4"}>{title}</p>
            </div>
        )
    }

    return (
        <div className={"w-full flex items-center justify-center"}>
            <div className={"w-max flex flex-col lg:flex-row items-start lg:items-center justify-center space-y-4 lg:space-y-0 lg:space-x-4 "}>
                {data.map((title, idx) => {
                    return $progressItem(title, idx)
                })}
            </div>
        </div>
    )
}

export default CampaignProgressBar
